import React from 'react';
import constants from 'lib/constants';
import CarouselImages from './CarouselImages';
import PlanHeader from './PlanHeader';

const CantFindPlan = () => <div>hmm... we couldn't find that Plan</div>;

// EXPORTED COMPONENT
// ===================================

class AppDashboardPreview extends React.PureComponent {
  render() {
    if (!this.props.match.params.dashboardProductId) {
      return <CantFindPlan />;
    }

    const dashboardProduct = constants.plansList[this.props.match.params.dashboardProductId];

    if (!dashboardProduct) {
      return <div />;
    }

    return (
      <div>
        <PlanHeader plan={dashboardProduct} {...this.props} />
        <CarouselImages plan={dashboardProduct} {...this.props} />
      </div>
    );
  }
}

export default AppDashboardPreview;



// WEBPACK FOOTER //
// ./src/routes/app-dashboard-preview/index.js